export const TermsOfUsePt = () => (
  <div className="max-w-4xl mx-auto px-4 py-12 bg-white">
    <div className="prose prose-lg max-w-none">
      <h1 className="text-4xl font-bold mb-8 text-gray-900">Termos de Uso</h1>
      <p className="text-sm text-gray-600">Última atualização: 03 de fevereiro de 2025</p>

      <p>
        Por favor, leia estes Termos de Uso (&quot;Termos&quot;) com atenção antes de usar o serviço DontTab
        (&quot;Serviço&quot;, &quot;nós&quot;, &quot;nos&quot; ou &quot;nosso&quot;) operado pela DontTab (&quot;Empresa&quot;).
      </p>

      <p>
        Seu acesso e uso do Serviço estão condicionados à sua aceitação e conformidade com
        estes Termos. Estes Termos se aplicam a todos os visitantes, usuários e outros que acessem ou usem o Serviço.
      </p>

      <p>
        Ao acessar ou usar o Serviço, você concorda em estar vinculado a estes Termos. Se você discordar
        de qualquer parte dos termos, não poderá acessar o Serviço.
      </p>

      <h2 className="text-2xl font-semibold mt-12 mb-6 text-gray-800">
        1. Contas e Registro
      </h2>
      <p>
        Ao criar uma conta conosco, você deve fornecer informações precisas, completas e atuais.
        O não cumprimento constitui violação dos Termos, que pode resultar na rescisão imediata da sua conta.
      </p>
      <p>
        Você é responsável por proteger sua senha e por todas as atividades que ocorrem em sua conta.
        Você concorda em não divulgar sua senha a terceiros.
      </p>

      <h2 className="text-2xl font-semibold mt-12 mb-6 text-gray-800">
        2. Assinaturas e Pagamentos
      </h2>
      <p>
        Algumas partes do Serviço são cobradas por assinatura. Você será cobrado antecipadamente
        em base recorrente e periódica (&quot;Ciclo de Cobrança&quot;). Os ciclos de cobrança são definidos
        em base mensal ou anual, dependendo do plano de assinatura selecionado.
      </p>
      <p>
        Os serviços de processamento de pagamento para usuários do DontTab são fornecidos por processadores
        de pagamento terceirizados (ex.: Stripe) e estão sujeitos aos seus respectivos termos de serviço e
        políticas de privacidade. Não somos responsáveis pelas ações ou omissões desses processadores.
      </p>

      <h2 className="text-2xl font-semibold mt-12 mb-6 text-gray-800">
        3. Política de Reembolso
      </h2>
      <p>
        Todas as taxas de assinatura não são reembolsáveis, exceto quando exigido por lei aplicável. Se você
        cancelar sua assinatura, continuará tendo acesso aos recursos pagos até o final do seu ciclo de
        cobrança atual, após o qual sua conta reverterá ao plano gratuito.
      </p>
      <p>
        Não fornecemos reembolsos ou créditos por períodos parciais de assinatura, downgrade de
        planos ou recursos não utilizados. Em caso de erro de cobrança, entre em contato conosco
        em até 30 dias da cobrança, e investigaremos e, se apropriado, emitiremos correção ou reembolso.
      </p>

      <h2 className="text-2xl font-semibold mt-12 mb-6 text-gray-800">
        4. Serviços e Integrações de Terceiros
      </h2>
      <p>
        O Serviço pode integrar ou conter links para serviços e sites de terceiros.
        Esses serviços não estão sob nosso controle, e não somos responsáveis por
        seu conteúdo, políticas de privacidade ou práticas.
      </p>
      <p>
        Sua interação com integrações de terceiros em nosso Serviço é regida pelos
        respectivos termos e políticas de privacidade desses terceiros. Recomendamos
        fortemente que você revise seus termos e condições e políticas de privacidade.
      </p>

      <h2 className="text-2xl font-semibold mt-12 mb-6 text-gray-800">
        5. Coleta e Uso de Dados
      </h2>
      <p>
        Ao usar nosso Serviço, você concorda que podemos coletar e usar seu endereço de e-mail e
        outras informações pessoais conforme descrito em nossa Política de Privacidade. Você reconhece que
        essas informações podem ser compartilhadas com provedores de serviço terceirizados conforme necessário
        para fornecer o Serviço.
      </p>

      <h2 className="text-2xl font-semibold mt-12 mb-6 text-gray-800">
        6. Propriedade Intelectual
      </h2>
      <p>
        O Serviço e seu conteúdo original, recursos e funcionalidade são e permanecerão
        propriedade exclusiva da DontTab e seus licenciadores. O Serviço é protegido por
        direitos autorais, marcas registradas e outras leis do Brasil e de países estrangeiros.
      </p>

      <h2 className="text-2xl font-semibold mt-12 mb-6 text-gray-800">
        7. Usos Proibidos
      </h2>
      <p>Você concorda em não usar o Serviço:</p>
      <ul className="list-disc pl-6 space-y-4 mb-8">
        <li className="text-gray-700">
          De qualquer forma que viole leis ou regulamentos aplicáveis
        </li>
        <li className="text-gray-700">
          Para transmitir material que contenha vírus ou outro código de computador prejudicial
        </li>
        <li className="text-gray-700">
          Para se passar ou tentar se passar pela Empresa ou outro usuário
        </li>
        <li className="text-gray-700">
          Para interferir ou interromper o Serviço ou servidores ou redes conectados ao Serviço
        </li>
      </ul>

      <h2 className="text-2xl font-semibold mt-12 mb-6 text-gray-800">
        8. Rescisão
      </h2>
      <p>
        Podemos encerrar ou suspender sua conta imediatamente, sem aviso prévio ou responsabilidade,
        por qualquer motivo, incluindo, sem limitação, se você violar os Termos.
      </p>
      <p>
        Após a rescisão, seu direito de usar o Serviço cessará imediatamente. Se desejar
        encerrar sua conta, você pode simplesmente deixar de usar o Serviço ou entrar em contato para
        exclusão da conta.
      </p>

      <h2 className="text-2xl font-semibold mt-12 mb-6 text-gray-800">
        9. Disponibilidade do Serviço
      </h2>
      <p>
        Nos esforçamos para manter o Serviço disponível o tempo todo, mas não garantimos
        operação ininterrupta, oportuna, segura ou livre de erros. O Serviço pode conter bugs,
        erros ou imprecisões que possam afetar sua funcionalidade. Não somos responsáveis por
        perda ou dano decorrentes de interrupções, tempo de inatividade, bugs, erros, perda de dados
        ou outros problemas relacionados à disponibilidade ou desempenho do Serviço.
      </p>
      <p>
        Reservamo-nos o direito de modificar, suspender ou descontinuar o Serviço (ou qualquer parte
        dele) a qualquer momento, com ou sem aviso, para manutenção, atualizações ou qualquer outro
        motivo. Não seremos responsáveis perante você ou terceiros por tal modificação,
        suspensão ou descontinuação.
      </p>

      <h2 className="text-2xl font-semibold mt-12 mb-6 text-gray-800">
        10. Isenção de Garantias
      </h2>
      <p>
        O SERVIÇO É FORNECIDO &quot;COMO ESTÁ&quot; E &quot;CONFORME DISPONÍVEL&quot;,
        SEM GARANTIAS DE QUALQUER TIPO, EXPRESSAS OU IMPLÍCITAS. NA MÁXIMA EXTENSÃO
        PERMITIDA PELA LEI APLICÁVEL, A DONTTAB ISENTA-SE DE TODAS AS GARANTIAS, EXPRESSAS OU IMPLÍCITAS,
        INCLUINDO, MAS NÃO SE LIMITANDO A, GARANTIAS IMPLÍCITAS DE COMERCIALIZAÇÃO, ADEQUAÇÃO A UM
        PROPÓSITO ESPECÍFICO, TÍTULO E NÃO VIOLAÇÃO.
      </p>
      <p>
        SEM LIMITAR O ACIMA, A DONTTAB NÃO GARANTE QUE: (A) O SERVIÇO ATENDERÁ SUAS NECESSIDADES OU EXPECTATIVAS;
        (B) O SERVIÇO SERÁ ININTERRUPTO, OPORTUNO, SEGURO OU LIVRE DE ERROS; (C) OS RESULTADOS OBTIDOS
        DO USO DO SERVIÇO SERÃO PRECISOS OU CONFIÁVEIS; (D) ERROS OU DEFEITOS NO SERVIÇO SERÃO CORRIGIDOS;
        OU (E) O SERVIÇO OU OS SERVIDORES QUE TORNAM O SERVIÇO DISPONÍVEL ESTEJAM LIVRES DE VÍRUS OU
        OUTROS COMPONENTES PREJUDICIAIS.
      </p>
      <p>
        VOCÊ RECONHECE QUE SEU USO DO SERVIÇO É POR SUA CONTA E RISCO. ESTA ISENÇÃO
        SE APLICA A TODOS OS USUÁRIOS, INCLUINDO USUÁRIOS DE ASSINATURA GRATUITA E PAGA. O PAGAMENTO DE
        TAXA DE ASSINATURA NÃO LHE DÁ DIREITO A GARANTIAS ADICIONAIS ALÉM DAS EXPRESSAMENTE
        ESTABELECIDAS NESTES TERMOS.
      </p>

      <h2 className="text-2xl font-semibold mt-12 mb-6 text-gray-800">
        11. Limitação de Responsabilidade
      </h2>
      <p>
        NA MÁXIMA EXTENSÃO PERMITIDA PELA LEI APLICÁVEL, EM NENHUM CASO A DONTTAB, NEM SEUS
        DIRETORES, EMPREGADOS, PARCEIROS, AGENTES, FORNECEDORES OU AFILIADOS SERÁ RESPONSÁVEL POR
        DANOS INDIRETOS, INCIDENTAIS, ESPECIAIS, CONSEQUENCIAIS OU PUNITIVOS, INCLUINDO, SEM
        LIMITAÇÃO, PERDA DE LUCROS, DADOS, USO, BOA VONTADE OU OUTRAS PERDAS INTANGÍVEIS, RESULTANTES
        DE: (A) SEU ACESSO OU USO OU INCAPACIDADE DE ACESSAR OU USAR O SERVIÇO; (B) QUALQUER
        CONDUTA OU CONTEÚDO DE TERCEIROS NO SERVIÇO; (C) QUALQUER CONTEÚDO OBTIDO DO SERVIÇO;
        (D) ACESSO, USO OU ALTERAÇÃO NÃO AUTORIZADOS DE SUAS TRANSMISSÕES OU CONTEÚDO;
        OU (E) BUGS, VÍRUS, ERROS OU IMPRECISÕES NO SERVIÇO, TENHA OU NÃO SIDO CAUSADOS
        POR NOSSA NEGLIGÊNCIA E TENHAMOS OU NÃO SIDO AVISADOS DA POSSIBILIDADE DE TAIS DANOS.
      </p>
      <p>
        NA MÁXIMA EXTENSÃO PERMITIDA PELA LEI APLICÁVEL, A RESPONSABILIDADE TOTAL DA DONTTAB POR
        TODAS AS REIVINDICAÇÕES DECORRENTES OU RELACIONADAS A ESTES TERMOS OU AO SERVIÇO NÃO EXCEDERÁ
        O MAIOR ENTRE: (A) O VALOR QUE VOCÊ PAGOU À DONTTAB PELO SERVIÇO DURANTE OS DOZE (12)
        MESES IMEDIATAMENTE ANTERIORES AO EVENTO QUE DEU ORIGEM À REIVINDICAÇÃO; OU (B) CEM
        DÓLARES AMERICANOS (USD $100,00).
      </p>
      <p>
        ESTA LIMITAÇÃO DE RESPONSABILIDADE SE APLICA A TODOS OS USUÁRIOS, INCLUINDO ASSINANTES PAGOS,
        E SE APLICARÁ INDEPENDENTEMENTE DA TEORIA JURÍDICA EM QUE A REIVINDICAÇÃO SE BASEIA.
      </p>

      <h2 className="text-2xl font-semibold mt-12 mb-6 text-gray-800">
        12. Indenização
      </h2>
      <p>
        Você concorda em defender, indenizar e isentar a DontTab e seus diretores, funcionários,
        agentes, licenciadores e fornecedores de e contra quaisquer reivindicações, ações,
        demandas, responsabilidades, danos, perdas, custos e despesas (incluindo honorários advocatícios
        razoáveis) decorrentes ou relacionados a: (a) seu uso do Serviço; (b) sua violação destes Termos;
        (c) sua violação de quaisquer direitos de terceiros; ou (d) qualquer conteúdo que você envie,
        publique ou transmita através do Serviço.
      </p>

      <h2 className="text-2xl font-semibold mt-12 mb-6 text-gray-800">
        13. Lei Aplicável e Resolução de Disputas
      </h2>
      <p>
        Estes Termos serão regidos e interpretados de acordo com as leis da República Federativa
        do Brasil, sem considerar suas disposições sobre conflito de leis.
      </p>
      <p>
        Qualquer disputa decorrente ou relacionada a estes Termos ou ao Serviço será primeiramente
        tentada ser resolvida através de negociação de boa-fé entre as partes. Se a disputa não puder
        ser resolvida por negociação em até trinta (30) dias, qualquer parte poderá buscar resolução
        nos tribunais competentes do Brasil.
      </p>
      <p>
        Nada nesta seção impedirá qualquer parte de buscar medida cautelar ou outro
        recurso equitativo em qualquer tribunal de jurisdição competente para prevenir a
        violação real ou ameaçada de direitos de propriedade intelectual.
      </p>

      <h2 className="text-2xl font-semibold mt-12 mb-6 text-gray-800">
        14. Força Maior
      </h2>
      <p>
        A DontTab não será responsável por qualquer falha ou atraso no cumprimento de suas obrigações
        sob estes Termos quando tal falha ou atraso resultar de circunstâncias além de nosso
        controle razoável, incluindo, mas não limitado a: atos de Deus, desastres naturais,
        pandemias, guerra, terrorismo, tumultos, ações governamentais, falhas de energia, falhas de
        internet ou telecomunicações, ataques cibernéticos, interrupções de provedores de serviço terceirizados,
        ou qualquer outro evento fora de nosso controle razoável (&quot;Evento de Força Maior&quot;).
      </p>
      <p>
        Em caso de Evento de Força Maior, nossas obrigações sob estes Termos serão
        suspensas pela duração de tal evento, e não seremos responsáveis por qualquer perda ou
        dano resultante. Usaremos esforços razoáveis para mitigar o impacto de tais eventos
        e retomar as operações normais o mais rápido possível.
      </p>

      <h2 className="text-2xl font-semibold mt-12 mb-6 text-gray-800">
        15. Alterações nos Termos
      </h2>
      <p>
        Reservamo-nos o direito, a nosso exclusivo critério, de modificar ou substituir estes Termos a qualquer
        momento. Se uma revisão for material, tentaremos fornecer aviso de pelo menos 30 dias
        antes de quaisquer novos termos entrarem em vigor.
      </p>
      <p>
        Ao continuar acessando ou usando nosso Serviço após essas revisões entrarem em vigor,
        você concorda em estar vinculado aos termos revisados. Se você não concordar com os novos termos,
        por favor pare de usar o Serviço.
      </p>

      <h2 className="text-2xl font-semibold mt-12 mb-6 text-gray-800">
        16. Fale Conosco
      </h2>
      <p className="mb-4">
        Se você tiver alguma dúvida sobre estes Termos, entre em contato conosco:
      </p>
      <ul className="list-disc pl-6 mb-8">
        <li className="text-gray-700">
          Por e-mail:{' '}
          <a
            className="text-blue-600 hover:underline"
            href="mailto:devnicknish@gmail.com"
          >
            devnicknish@gmail.com
          </a>
        </li>
      </ul>
    </div>
  </div>
);
